
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import Read from "./read.vue";
@Component({
  components: {
    Read,
  },
})
export default class Name extends mixins(listMixin) {
  @Prop()
  private part: any;
  @Watch("part", { immediate: true })
  private partChange() {
    if (this.part === "便携式体检机") {
      this.getList();
    }
  }
  private ifShowRead: any = false;
  private data: any = [];
  private readId: any = "";
  private goRead(item: any) {
    this.readId = item.id;
    this.ifShowRead = true;
  }
  getList() {
    const params: any = {
      params: {
        search: this.filters.search,
        分配状态: this.filters["分配状态"],
        标注状态: this.filters["标注状态"],
        category: this.filters["分类"],
        user_id: this.filters["标注员"],
        order_field: "创建时间",
        order_value: this.filters.sort_value,
        current_page: this.filters.current_page,
        page_num: this.filters.page_count,
        kind: "任务管理",
      },
    };
    // localStorage.setItem("rengwuguanliliFilter", JSON.stringify(this.filters));
    // const loading = this.$loading({
    //   lock: true,
    //   text: "加载中……",
    //   spinner: "el-icon-loading",
    //   customClass: "loadClass",
    //   background: "rgba(255, 255, 255, 0.7)",
    // });
    this.data = [
      {
        id: "1",
        时间: "2022-12-12 12:00:00",
        心率范围: "66-114",
        静息心率: "66-116",
        运动心率: "66-116",
      },
      { id: "2" },
      { id: "3" },
      { id: "4" },
      { id: "5" },
      { id: "6" },
      { id: "7" },
    ];
    this.filters.total_count = 100;
    // GetRenwuList(this, params, loading)
    //   .then((data: any) => {
    //     loading.close();
    //     this.data = data.data;
    //     this.filters.total_count = data.total_count;
    //     this.filters.total_page = data.total_page;
    //     if (this.data.length === 0) {
    //       this.ifShowEmpty = true;
    //     } else {
    //       this.ifShowEmpty = false;
    //     }
    //   })
    //   .catch(() => {
    //     loading.close();
    //   });
  }
}
